export const relevantSearchActionConstants = {
  FETCH_RELEVANT_SEARCH_SCHEME: "FETCH_RELEVANT_SEARCH_SCHEME",
  FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS: "FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS",
  FETCH_RELEVANT_SEARCH_FACET: "FETCH_RELEVANT_SEARCH_FACET",
  ACTION_CHANGE_RELATED_LANG: "ACTION_CHANGE_RELATED_LANG",
  FETCH_RELEVANT_SEARCH_FACET_AGGREGATE: "FETCH_RELEVANT_SEARCH_FACET_AGGREGATE",
  FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS: "FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS",
  FETCH_RELEVANT_SEARCH_FACET_SUCCESS: "FETCH_RELEVANT_SEARCH_FACET_SUCCESS",
  ACTION_RELATED_TYPE: "ACTION_RELATED_TYPE",
};

export const relevantSearchActions = {
  fetchRelevantSearchScheme: () => ({
    type: relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_SCHEME,
  }),
  actionChangeRelatedLang: (lang) => {
    return {
      type: relevantSearchActionConstants.ACTION_CHANGE_RELATED_LANG,
      data: { lang }
    };
  },
  fetchRelevantSearchSchemeSuccess: (sections, relatedLangs) => ({
    type: relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS,
    data: { sections, relatedLangs }
  }),
  fetchRelevantSearchFacetAggregate: (lang, query) => ({
    type: relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE,
    data: { lang, query }
  }),
  fetchRelevantSearchFacetAggregateSuccess: (results, lang) => ({
    type: relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS,
    data: { results, lang }
  }),
};
